export const TenantList = {
    Ascend: {
        slug: "ascend",
        name: "アセンド株式会社",
    },
    AscendLabor: {
        slug: "ascend-labor",
        name: "アセンド株式会社(労務)",
    },
    DaisanLogitech: {
        slug: "daisanlogi",
        name: "株式会社大三ロジテック",
    },
    AscendUnsou: {
        slug: "ascend-unsou",
        name: "アセンド運送",
    },
    HachidaiDemo: {
        slug: "hachidaidemo",
        name: "八大デモ",
    },
    // MEMO: Demoという名称がついているが本番アカウント
    OginoDemoIppan: {
        slug: "oginodemo-ik",
        name: "荻布倉庫一般貨物",
    },
    Hachidai: {
        slug: "hachidai",
        name: "八大株式会社",
    },
    Yoshizawa: {
        slug: "yoshizawatp",
        name: "吉沢運送株式会社",
    },
    Yanagawa: {
        slug: "yanagawa-godo",
        name: "株式会社柳川合同",
    },
    TrialYanagawa: {
        slug: "trial-yanagawa",
        name: "柳川合同トライアル",
    },
    AizuTsuuun: {
        slug: "aizu-tsuuun",
        name: "會津通運株式会社",
    },
    AizuTsuuunDemo: {
        slug: "aizu-tsuuun-demo",
        name: "會津通運株式会社（デモ）",
    },
    Minato: {
        slug: "minato-tpg",
        name: "みなと梱包運送株式会社",
    },
    Kasugai: {
        slug: "kasugai",
        name: "春日井運輸株式会社（旧）",
    },
    Fct: {
        slug: "fct",
        name: "株式会社エフ・シー・ティー",
    },
    TokyoUnsou: {
        slug: "tokyo-unsou",
        name: "東京運送株式会社",
    },
    Nishifuku: {
        slug: "nishifuku",
        name: "西福運送株式会社",
    },
    Nishiun: {
        slug: "nishiun",
        name: "株式会社西運",
    },
    Abex: {
        slug: "abex",
        name: "株式会社アベックス",
    },
    SunFoods: {
        slug: "sun-foods",
        name: "サン・フーズ株式会社",
    },
    SipStandard: {
        slug: "sip-standard",
        name: "SIP標準テナント",
    },
    RyuTsu: {
        slug: "ryu-tsu",
        name: "流通株式会社",
    },
    TanigawaShouji: {
        slug: "tanigawa-shouji",
        name: "株式会社谷川商事",
    },
    TodorokiUnyu: {
        slug: "todoroki-unyu",
        name: "（本社）とどろき運輸株式会社",
    },
    TodorokiShikoku: {
        slug: "todoroki-shikoku",
        name: "（四国営業所）とどろき運輸株式会社",
    },
    Tisco: {
        slug: "tisco",
        name: "株式会社ティスコ運輸",
    },
    FukushimaUnyu: {
        slug: "fukushima-unyu",
        name: "服島運輸株式会社",
    },
    ShutokenLogi: {
        slug: "shutoken-logi",
        name: "首都圏ロジスティクス",
    },
    Foryou: {
        slug: "foryou",
        name: "株式会社朋友",
    },
    Hosei: {
        slug: "hosei",
        name: "芳誠流通株式会社",
    },
    ItoUnyu: {
        slug: "itounyu",
        name: "有限会社伊藤運輸",
    },
    TorikaUnyu: {
        slug: "torika-unyu",
        name: "有限会社鳥果運輸",
    },
    TsurumaruKaiun: {
        slug: "tsurumaru",
        name: "鶴丸海運株式会社",
    },
    Maruhari: {
        slug: "maruhari",
        name: "株式会社マルハリ",
    },
    KoeiUnyu: {
        slug: "koueitrucks",
        name: "晃永運輸株式会社",
    },
    MirailLog: {
        slug: "mirai-log",
        name: "株式会社mirai計画",
    },
    KawakamiUnyu: {
        slug: "kawakamiunyu",
        name: "有限会社川上運輸",
    },
    AsutoIza: {
        slug: "asuto-iza",
        name: "株式会社アスト中本",
    },
    DPNetwork: {
        slug: "dpn",
        name: "DPネットワーク株式会社",
    },
    keiyoRyutsu: {
        slug: "k-yo",
        name: "京葉流通倉庫株式会社",
    },
    MarutamaUnsou: {
        slug: "marutama",
        name: "丸玉運送",
    },
    NipponNizukuri: {
        slug: "nippon-nizukuri",
        name: "日本荷造運送",
    },
    NiwaUnsou: {
        slug: "niwa-unsou",
        name: "株式会社仁和運送",
    },
    Yamanishi: {
        slug: "yamanishi",
        name: "株式会社山西",
    },
    Aikawa: {
        slug: "aikawa",
        name: "株式会社アイカワ",
    },
    SekiyuYuso: {
        slug: "sekiyu-yuso",
        name: "石油輸送株式会社",
    },
    ALogi: {
        slug: "a-logi",
        name: "株式会社A-LOGI",
    },
    TrialAlogi: {
        slug: "trial_a-logi",
        name: "A-LOGIトライアル",
    },
    DaieiTransport: {
        slug: "daieitransport",
        name: "有限会社大栄運送",
    },
    SanshinUnso: {
        slug: "sansin-unso",
        name: "三進運送株式会社",
    },
    NhAomori: {
        slug: "nh-aomori",
        name: "株式会社東北高速道青森",
    },
    TakeuchiUk: {
        slug: "takeuchi-uk",
        name: "竹内運輸工業株式会社",
    },
    Umesato: {
        slug: "umesato-butsuryu",
        name: "株式会社梅里物流サービス",
    },
    MasuyamaKamotsu: {
        slug: "masuyama-kamotsu",
        name: "増山貨物自動車株式会社",
    },
    Sadokisen: {
        slug: "sadokisen-unyu",
        name: "佐渡汽船運輸株式会社",
    },
    MeikoUnyu: {
        slug: "meikounyu",
        name: "明光運輸株式会社",
    },
    CosmoUnyu: {
        slug: "cosmounyu",
        name: "コスモ運輸株式会社",
    },
    HeiseiNousan: {
        slug: "heiseinousan",
        name: "平成農産運輸株式会社",
    },
    ButsuryuKenkyujo: {
        slug: "butsuryukenkyujo",
        name: "株式会社物流研究所",
    },
    MeirinUnyu: {
        slug: "meirinunyu",
        name: "明倫運輸株式会社",
    },
    KyowaCargo2: {
        slug: "kyowa-cargo2",
        name: "株式会社共和貨物自動車",
    },
    Ecocrew: {
        slug: "ecocrew",
        name: "株式会社エコ・クルー",
    },
    Jyohoku: {
        slug: "jyohoku",
        name: "城北運輸株式会社",
    },
    Prv: { slug: "prv", name: "プリヴェ運輸株式会社" },
    Next: { slug: "next", name: "株式会社NEXT" },
    Shiwakamotsu: {
        slug: "shiwakamotsu",
        name: "志和貨物自動車株式会社",
    },
    YKamotsu: {
        slug: "y-kamotsu",
        name: "山梨貨物自動車株式会社",
    },
    Towaunyu: {
        slug: "towaunyu",
        name: "東和運輸株式会社",
    },
    Marutaamazon: {
        slug: "maruta-amazon",
        name: "マルタアマゾン株式会社",
    },
    Toushinunnyu: {
        slug: "toushinunnyu",
        name: "東伸運輸株式会社",
    },
    Nisshinnkikou: {
        slug: "nisshinnkikou",
        name: "日神機工株式会社",
    },
    Bloom: {
        slug: "bloom",
        name: "株式会社ブルーム",
    },
    EjiriTransport: {
        slug: "ejiri-transport",
        name: "江尻運送株式会社",
    },
    AnjyoSoukounyu: {
        slug: "anjyo-soukounyu",
        name: "安城倉庫運輸株式会社",
    },
    Rebic: {
        slug: "rebic",
        name: "株式会社レビック",
    },
    Rebic2: {
        slug: "Rebic",
        name: "株式会社Rebic",
    },
    Demo3: {
        slug: "demo3",
        name: "導入支援運送株式会社",
    },
    Nishiki: {
        slug: "nishiki-ex",
        name: "株式会社ニシキ運送",
    },
    TokyoNisshoku: {
        slug: "tokyonisshoku",
        name: "東京日食株式会社",
    },
    HannaTp: {
        slug: "hanna-tp",
        name: "株式会社ハンナ",
    },
    SBSFreight: {
        slug: "sbs-freight",
        name: "SBSフレイトサービス株式会社",
    },
    NatushimaUnyu: {
        slug: "natushima-unyu",
        name: "夏島運輸株式会社",
    },
    Kyoritsunyu: {
        slug: "kyoritsunyu",
        name: "協立運輸商事株式会社",
    },
    KyowaShokai: {
        slug: "kyowa-shokai",
        name: "株式会社協和商会",
    },
    HarumiUnyu: {
        slug: "harumi-unyu",
        name: "晴海運輸株式会社",
    },
    KbLine: {
        slug: "kb-line",
        name: "KB LINE株式会社",
    },
    KusLogi: {
        slug: "kus-logi",
        name: "株式会社K.U.S.ロジスティック・サポート",
    },
    Horest: {
        slug: "horest",
        name: "株式会社ホレスト",
    },
    MarueUnyu: {
        slug: "marue-unyu",
        name: "株式会社丸江運輸",
    },
    ShimizuUnyu: {
        slug: "shimizu-unyu",
        name: "清水運輸グループ",
    },
    OyuUnsou: {
        slug: "oyu-unsou",
        name: "大湯運送株式会社",
    },
    ShineiUnyu: {
        slug: "shinei-unyu",
        name: "神栄運輸株式会社",
    },
    NisseiUnyu: {
        slug: "nissei-unyu",
        name: "日成運輸株式会社",
    },
    AsahikawaKogata: {
        slug: "asahikawakogata",
        name: "旭川コガタグループ",
    },
    SugaiExpress: {
        slug: "sugai-express",
        name: "Sugai Express Cargo株式会社",
    },
    AiLine: {
        slug: "ai-line",
        name: "株式会社アイライン",
    },
    ACarry: {
        slug: "a-carry",
        name: "株式会社A-CARRY",
    },
    SeishinUnyu: {
        slug: "seishin-unyu",
        name: "静神運輸株式会社",
    },
    Shimohana: {
        slug: "shimohana",
        name: "シモハナ物流",
    },
    GlobalAirCargo: {
        slug: "global-air-cargo",
        name: "株式会社グローバルエアカーゴ",
    },
    TokaiKyuso: {
        slug: "tokai-kyuso",
        name: "東海急送株式会社",
    },
    EbinoKosan: {
        slug: "ebinokk",
        name: "えびの興産株式会社",
    },
    Toransia: {
        slug: "toransia",
        name: "株式会社トランシア",
    },
    TakiyamaTrial: {
        slug: "takiyama_trial",
        name: "株式会社滝山（トライアル）",
    },
    Takiyama: {
        slug: "takiyama",
        name: "株式会社滝山",
    },
    ChubuExp: {
        slug: "chubu-exp",
        name: "中部急送株式会社",
    },
    MeibiUnyu: {
        slug: "meibi-unyu",
        name: "名備運輸",
    },
    MaxamLogi: {
        slug: "maxam-logi-tr3",
        name: "マクサム通運株式会社",
    },
    HakueiUnyu: {
        slug: "hakuei-unyu",
        name: "有限会社博栄運輸",
    },
    IshikawaUnyu: {
        slug: "ishikawa-unyu-sk",
        name: "石川運輸倉庫株式会社",
    },
    Tsubaki: {
        slug: "tsubaki",
        name: "椿運輸株式会社",
    },
    AndoUnyu: {
        slug: "ando-unyu",
        name: "有限会社安藤運輸",
    },
    NakahamaUnyu: {
        slug: "nakahamaunyu",
        name: "有限会社中浜運輸",
    },
    Nagata: {
        slug: "nagata",
        name: "株式会社NAGATA",
    },
    FukuyamaMizuho: {
        slug: "fukuyama-mizuho",
        name: "福山瑞穂運輸株式会社",
    },
    NippatsuUnyu: {
        slug: "nhktrs",
        name: "日発運輸株式会社",
    },
    NippatsuUnyuDemo: {
        slug: "nhktrs.demo",
        name: "日発運輸株式会社デモ",
    },
    YamahiroUnyu: {
        slug: "yamahiro-unyu",
        name: "株式会社やまひろ運輸",
    },
    DaitoUnyu: {
        slug: "daito-unyu",
        name: "大斗運輸株式会社",
    },
    Sanyo: {
        slug: "sanyo",
        name: "株式会社三洋エクスプレス",
    },
    // NOTE: まるだい運輸倉庫には "MarudaiUnyu" もあるので注意。 "MusTest" が新しいので、基本的には "MusTest" を使う。
    MarudaiUnyu: {
        slug: "marudai-unyu",
        name: "株式会社まるだい運輸倉庫",
    },
    KasugaiTruck: {
        slug: "kasugai-truck",
        name: "春日井運輸株式会社",
    },
    Maruwn: {
        slug: "maruwn",
        name: "株式会社丸運",
    },
    Sankyu: {
        slug: "sankyu",
        name: "山九株式会社",
    },
    Maruzeng: {
        slug: "maruzeng",
        name: "丸善株式会社",
    },
    FujiUnyu: {
        slug: "fuji-unyu",
        name: "フジ運輸株式会社",
    },
    KawamuraUnsoten: {
        slug: "kawamura-unsoten",
        name: "株式会社川村運送店",
    },
    ChugokuNishiriku: {
        slug: "nishiriku",
        name: "中国ニシリク株式会社",
    },
    Dairin: {
        slug: "dairin",
        name: "大輪総合運輸",
    },
    TaikohUnyu: {
        slug: "taikoh-unyu",
        name: "大興運輸株式会社",
    },
    ImanariUnso: {
        slug: "imanari-unso",
        name: "今成運送株式会社",
    },
    Tohbu: {
        slug: "tohbu",
        name: "東部ネットワーク株式会社",
    },
    KoyoEnet: {
        slug: "koyo-enet",
        name: "株式会社光葉産業運輸",
    },
    ShingouUnyu: {
        slug: "shingou-unyu",
        name: "有限会社新郷運輸",
    },
    TAT: {
        slug: "TAT",
        name: "株式会社T．A．T",
    },
    AsahiSangyo: {
        slug: "asahi-sangyo",
        name: "朝日産業株式会社",
    },
    Ebinokk3: {
        slug: "ebinokk-3",
        name: "えびの興産株式会社",
    },
    AxiaLogi: {
        slug: "axia-logi",
        name: "アクシアロジ",
    },
    ShineiKinnzoku: {
        slug: "shineikinnzoku",
        name: "新英金属株式会社",
    },
    Athlete: {
        slug: "athlete",
        name: "株式会社アスリート",
    },
    FCargo: {
        slug: "f-cargo",
        name: "有限会社フレッシュカーゴ",
    },
    Owaririkuun: {
        slug: "owaririkuun",
        name: "尾張陸運株式会社",
    },
    Oosaki: {
        slug: "oosaki",
        name: "株式会社大崎",
    },
    Marusoh: {
        slug: "marusoh",
        name: "株式会社丸総",
    },
    MaruzenHoldings: {
        slug: "maruzen-holdings",
        name: "マルゼンホールディングス株式会社",
    },
    KobeShoun: {
        slug: "akafuji",
        name: "神戸商運株式会社",
    },
    // NOTE: まるだい運輸倉庫には "MarudaiUnyu" もあるので注意。 "MusTest" が新しいので、基本的には "MusTest" を使う。
    MusTest: {
        slug: "mus-test",
        name: "株式会社まるだい運輸倉庫",
    },
    NLogipartners: {
        slug: "n-logipartners",
        name: "株式会社N-LOGIパートナーズ",
    },
    Toukaibuturyuu: {
        slug: "toukaibuturyuu",
        name: "東開物流株式会社",
    },
    Noshirounyu: {
        slug: "noshirounyu",
        name: "能代運輸株式会社",
    },
    VGroup: {
        slug: "v-group",
        name: "株式会社ビクトリー",
    },
    AkitaInc2: {
        slug: "akita-inc2",
        name: "アキタ株式会社",
    },
    TaiyoUnyu: {
        slug: "taiyo-s36",
        name: "Taiyo運輸建設株式会社",
    },
    Shoujiunso: {
        slug: "shoujiunso",
        name: "株式会社庄子運送",
    },
    KansaiTeion: {
        slug: "kansai-teion",
        name: "関西低温株式会社",
    },
    SanyuButsuryu: {
        slug: "sanyu-butsuryu",
        name: "三友物流株式会社",
    },
    Suzuken8888: {
        slug: "suzuken8888",
        name: "鈴健興業株式会社",
    },
    Yashima: {
        slug: "yasima",
        name: "株式会社屋島運送",
    },
    Hokkaikogyo: {
        slug: "hokkaikogyo",
        name: "株式会社北海興業",
    },
    MarudaiTruck: {
        slug: "marudai-truck",
        name: "丸大トラック株式会社",
    },
    WagatsumaShoji: {
        slug: "wagatsuma-shoji",
        name: "株式会社我妻商事",
    },
    Asahiunnyu: {
        slug: "asahiunnyu",
        name: "（旧）株式会社朝日運輸",
    },
    AsahiUnyu: {
        slug: "asahi-unyu",
        name: "朝日運輸",
    },
    KeiunShoji: {
        slug: "keiun-shoji",
        name: "京運商事株式会社",
    },
    Northwing: {
        slug: "northwing",
        name: "株式会社ノースウイング",
    },
    SendaiHaiso: {
        slug: "sendai-haiso",
        name: "株式会社仙台配送",
    },
    GenesisSapporo: {
        slug: "genesis-sapporo",
        name: "有限会社ジェネシス",
    },
    TanakaUnyu: {
        slug: "tanaka-unyu",
        name: "株式会社田中運輸",
    },
    Fujinami: {
        slug: "fujinami",
        name: "藤波運輸株式会社",
    },
    Hyoko: {
        slug: "hyoko",
        name: "株式会社ヒョウコウ",
    },
    TobuUnyu: {
        slug: "tobu",
        name: "東部運輸",
    },
    SouwaUnyu: {
        slug: "souwa-unyu",
        name: "総和運輸株式会社",
    },
    RyukyuUnyu: {
        slug: "ryukyu-unyu",
        name: "琉球物流運輸株式会社",
    },
    SenzokuikeUnyu: {
        slug: "senzokuikeunyu",
        name: "洗足池運輸株式会社",
    },
    YasSalvage: {
        slug: "yassalvage",
        name: "株式会社野洲サルベージ",
    },
    FukuokaSoko: {
        slug: "fukuoka-soko",
        name: "福岡倉庫株式会社",
    },
    MarusoGroup: {
        slug: "maruso-group",
        name: "マルソーグループ",
    },
    Fkk: {
        slug: "fkk",
        name: "伏木海陸運送株式会社",
    },
    Ascendlogi: {
        slug: "ascendlogi",
        name: "アセンドロジ株式会社",
    },
    NipponRikuso: {
        slug: "nippon-rikuso",
        name: "日本陸送株式会社",
    },
    SaneiUnyu: {
        slug: "sanei-unyu",
        name: "三栄運輸株式会社",
    },
    ShinguUnso: {
        slug: "shingu-unso",
        name: "株式会社新宮運送",
    },
    NagoyaTobu: {
        slug: "nagoya-tobu",
        name: "名古屋東部陸運株式会社",
    },
    Juwa: {
        slug: "juwa",
        name: "十和運送株式会社",
    },
    Marushin: {
        slug: "marushin",
        name: "丸進運輸株式会社",
    },
    Chibasyoukai: {
        slug: "chibasyoukai",
        name: "株式会社千葉商会トランスポート柏",
    },
    RealizeLogi: {
        slug: "realize-logi",
        name: "リアライズ株式会社",
    },
    AndohUnyu: {
        slug: "andoh-unyu",
        name: "安藤運輸株式会社",
    },
    DairinIct: {
        slug: "dairin-itc",
        name: "大輪総合運輸株式会社",
    },
    KkGion: {
        slug: "kk-gion",
        name: "株式会社ギオン",
    },
    Demo1unkouNanken: {
        slug: "demo1unkouNanken",
        name: "デモ（1運行N案件）",
    },
};
export const AscendUnsouTenant = {
    ...TenantList.AscendUnsou,
    id: "2711321913353970",
};
export const AscendTenantList = [
    TenantList.AscendUnsou,
    TenantList.Demo3,
];
//# sourceMappingURL=tenants.js.map